/** Sala Whereby no Appointment. O POST legado grava objeto; o FHIR R5 usa array. */
export interface WherebyRoom {
  addressUrl: string;
  sessionKey: string;
}

export function readWherebyRoom(virtualService: unknown): WherebyRoom | undefined {
  if (!virtualService) return undefined;

  const entry = Array.isArray(virtualService)
    ? virtualService[0]
    : virtualService;

  if (!entry || typeof entry !== "object") return undefined;

  const addressUrl = (entry as { addressUrl?: string }).addressUrl;
  if (!addressUrl) return undefined;

  return {
    addressUrl,
    sessionKey: (entry as { sessionKey?: string }).sessionKey || "",
  };
}

/** Formato que verifyEncounter já lê em virtualService[0]. */
export function wherebyRoomAsArray(room: WherebyRoom): WherebyRoom[] {
  return [room];
}
